import { Route } from "@angular/router";
import { authGuard } from "@core/guards";
import { AgentSettingsPageComponent } from "./components/agent-settings-page/agent-settings-page.component";
import { BrandingPageComponent } from "./components/branding-page/branding-page.component";
import { DocumentSettingsPageComponent } from "./components/document-settings-page/document-settings-page.component";
import { DocumentTemplatesPageComponent } from "./components/document-templates-page/document-templates-page.component";
import { EmailSettingsPageComponent } from "./components/email-settings-page/email-settings-page.component";
import { EmailTemplatesPageComponent } from "./components/email-templates-page/email-templates-page.component";
import { IntegrationsPageComponent } from "./components/integrations-page/integrations-page.component";
import { ManageTagsPageComponent } from "./components/manage-tags-page/manage-tags-page.component";
import {
  OrganisationDetailsPageComponent
} from "./components/organisation-details-page/organisation-details-page.component";
import { RemindersPageComponent } from "./components/reminders-page/reminders-page.component";
import { SettingsPageComponent } from "./components/settings-page/settings-page.component";
import {
  TextMessagesTemplatesPageComponent
} from "./components/text-messages-templates-page/text-messages-templates-page.component";
import {
  UsersAndPermissionsPageComponent
} from "./components/users-and-permissions-page/users-and-permissions-page.component";

export function getSettingsRoutes(): Route[] {
  return [
    {
      path: 'settings',
      canActivate: [authGuard],
      canActivateChild: [authGuard],
      children: [
        {
          title: 'Settings',
          path: '',
          component: SettingsPageComponent,
        },
        {
          title: 'My Account',
          path: 'my-organisation',
          component: OrganisationDetailsPageComponent,
        },
        {
          title: 'Accounts',
          path: 'accounts',
          component: UsersAndPermissionsPageComponent,
        },
        {
          title: 'Agent Settings',
          path: 'agent-settings',
          component: AgentSettingsPageComponent,
        },
        {
          title: 'Branding',
          path: 'branding',
          component: BrandingPageComponent,
        },
        {
          title: 'Tags',
          path: 'tags',
          component: ManageTagsPageComponent,
        },
        {
          title: 'Cover Letter Templates',
          path: 'cover-letter-templates',
          component: DocumentTemplatesPageComponent,
        },
        {
          title: 'Email Settings',
          path: 'email-settings',
          component: EmailSettingsPageComponent,
        },
        {
          title: 'Email Templates',
          path: 'email-templates',
          component: EmailTemplatesPageComponent,
        },
        {
          title: 'Integrations',
          path: 'integrations',
          component: IntegrationsPageComponent,
        },
        {
          title: 'Document Settings',
          path: 'document-settings',
          component: DocumentSettingsPageComponent,
        },
        {
          title: 'SMS Templates',
          path: 'sms-templates',
          component: TextMessagesTemplatesPageComponent,
        },
        {
          title: 'Reminders',
          path: 'reminders',
          component: RemindersPageComponent,
        },
      ]
    }
  ];
}
